<template>
  <div id="root" class="toggle-menu">
    <menu-component whiteFont="true"></menu-component>
    <b-row class="full-height bg-img">
      <b-container class="alinov-header center-text">
        <b-row>
          <b-col>
            <h1>Pedidos</h1>
            <span>Envíanos tu pedido</span>
            <br/><br>
            <a class="link-to-section" href="#request-form">
              <i class="fas fa-chevron-circle-down"></i>
            </a>
          </b-col>
        </b-row>
      </b-container>
      <div id="request-form" class="alinov-info-container">
        <b-container class="info">
          <b-row class="title">
            <h1>Haz un pedido</h1>
          </b-row>
          <b-row>
            <b-col>
              <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                <b-form-group
                  id="email_address_gr"
                  label="Correo Electrónico:"
                  label-for="email_address_input"
                >
                  <b-form-input
                    id="email_address_input"
                    type="email"
                    v-model="form.email"
                    required
                    placeholder="Escribe tu correo electrónico"
                  />
                </b-form-group>

                <b-form-group id="name_gr" label="Nombre:" label-for="name_input">
                  <b-form-input
                    id="name_input"
                    type="text"
                    v-model="form.name"
                    required
                    placeholder="Escribe tu nombre"
                  />
                </b-form-group>

                <b-form-group id="product_gr" label="Producto:" label-for="product_input">
									<b-row>
										<b-col>
											<b-form-select id="product_input" :options="products" required v-model="form.product"/>
										</b-col>
										<b-col>
											<b-form-input type="number" placeholder="Escribe una cantidad" min="0" id="quantity_input" required v-model="form.quantity"/>
										</b-col>
										<b-col>
											<b-form-select id="unit_input" :options="units" required v-model="form.unit"/>
										</b-col>
									</b-row>
                </b-form-group>

								<b-form-group>
									<b-form-textarea
										id="comment_ts"
										v-model="form.comment"
										placeholder="Agrega un comentario"
										rows="3"
										max-rows="6"
									/>
								</b-form-group>

                <b-button class="alinov" type="submit" variant="success">Enviar</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-row>
    <footer-component></footer-component>
  </div>
</template>

<script>
import Menu from "../shared/Menu.vue";
import Footer from "../shared/Footer.vue";
import $ from 'jquery'

export default {
  name: "Services",
  components: {
    "menu-component": Menu,
    "footer-component": Footer
	},
	beforeMount() {
    $(function() {
      $('a.link-to-section').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top-80}, 500, 'linear');
      });
    });

    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
			var headerHeight = 500;
			// $('.alinov-header').height() + 100;

      if (scroll >= headerHeight) {
					$(".toggle-menu .alinov-navbar").addClass("white-bg");
					$(".toggle-menu .alinov-navbar").removeClass("white-font");
      } else {
				$(".toggle-menu .alinov-navbar").removeClass("white-bg");
				$(".toggle-menu .alinov-navbar").addClass("white-font");
      }
    });
  },
	data() {
      return {
        form: {
          email: '',
					name: '',
					comment: '',
					product: null,
					quantity: '',
					unit: null
        },
				products: [{ text: 'Selecciona un producto', value: null }, 'Fuel Flex'],
				units: [{ text: 'Selecciona una unidad', value: null }, 'Litros', 'Unidades'],
        show: true
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
      },
      onReset(evt) {
        evt.preventDefault()
        /* Reset our form values */
        this.form.email = ''
				this.form.name = ''
				this.form.comment = ''
				this.form.product = null
				this.form.quantity = null
				this.form.unit = null
        /* Trick to reset/clear native browser form validation state */
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
			}
		}
};
</script>

<style lang="scss" scoped>
.full-height {
	background-image: linear-gradient( 
		rgba(0, 0, 0, 0.4), 
		rgba(0, 0, 0, 0.4) ),  
		url("../assets/images/services_bg.jpg");
}

#product_gr {
	margin: 4rem 0;
}

.alinov.btn {
	margin-top: 2rem;
}
</style>
